<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-06-30 14:13:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-15 16:06:15
-->
<template>
  <!-- 部门列表 -->
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <v-card v-if="$route.name == 'department_list'">
        <mrc_ess_addBtn v-btnAuth="['add-department']"
                        @handleAdd="handleAdd"
                        :del="false"></mrc_ess_addBtn>
        <v-card-text>
          <!-- <div class="title">
            <span class="departmentName">{{
              $t('label_Department_name')
            }}</span>
            <span class="staffNum">{{ $t('label_Number_of_employees') }}</span>
          </div> -->
          <v-sheet class="d-flex align-center justify-space-between px-5 mb-4 text--secondary">
            <v-sheet class="ml-2 text--secondary">{{
              $t('label_Department_name')
            }}</v-sheet>
            <v-sheet class="staffNum text--secondary"
                     width="15vw">{{
              $t('label_Number_of_employees')
            }}</v-sheet>
          </v-sheet>
          <template v-if="Array.isArray(list) && list.length > 0">
            <div v-for="(treelist,index) in list"
                 :key="index"
                 class="box"
                 :class="index!==0?'mt-5':''"
                 style="border-radius:8px;border: 1px solid #e8e8e8;overflow:hidden;">
              <v-treeview selected-color="primary"
                          hoverable
                          open-on-click
                          transition
                          item-key="uuid"
                          item-children="children"
                          expand-icon="arrow_drop_down"
                          :items="[treelist]">
                <template v-slot:label="{ item }">
                  {{ INT(item.org_level_name) }}
                </template>
                <template v-slot:append="{ item }">
                  <v-sheet width="15vw"
                           class="d-flex justify-space-between align-center">
                    <span> {{ item.staff_number }}</span>
                    <menu-list :list="[
                      {
                        name: $t('label_View'),
                        type: 'view',
                        show: hasBtn('view-department'),
                      },
                      {
                        name: $t('label_Edit'),
                        type: 'edit',
                        show: hasBtn('edit-department'),
                      },
                      {
                        name: $t('label_delete'),
                        type: 'del',
                        show: hasBtn('delete-department'),
                      },
                    ]"
                               @handleClick="handleClick($event, item)">
                      <template v-slot:showAction>
                        <v-icon v-btnAuth="[
                          'view-department',
                          'edit-department',
                          'delete-department',
                        ]">mdi-dots-vertical</v-icon>
                      </template>
                    </menu-list>
                  </v-sheet>
                </template>
              </v-treeview>
            </div>
          </template>
          <template v-else>
            <mrc_ess_noContent></mrc_ess_noContent>
          </template>
        </v-card-text>
      </v-card>
      <router-view v-else></router-view>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { getList, delDepartment } from '@/service/api/departmentManage'
export default {
  components: {},
  props: {},
  data () {
    return {
      skLoading: true,
      org_level_code: '',
      list: [],
    }
  },
  created () { },
  async mounted () {
    this.skLoading = true
    const uuid = this.$route.params.uuid || this.$store.state.uuid
    this.org_level_code =
      this.$route.params.code || this.$store.state.orgLevelCode
    await this.getData()
    this.skLoading = false
  },
  methods: {
    delData (uuid) {
      this.Recursion(this.list, uuid)
    },
    Recursion (arr, uuid) {
      if (!arr || (arr.length && arr.length <= 0)) return ''
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1)
        } else {
          if (item.children) {
            this.Recursion(item.children, uuid)
          }
        }
      })
    },
    async getData () {
      const list = await getList({
        org_level_code: this.org_level_code,
      })
      if (list.code == 200) {
        this.list = list.data
      }
    },
    // 添加部门
    handleAdd () {
      this.$store.commit('set_uuid2', '')
      this.$router.push({
        name: 'department_add',
      })
    },
    handleClick ({ item, index }, obj) {
      if (item.type == 'view') {
        this.$store.commit('set_subPage_name', obj.org_level_name)
        this.$store.commit('set_uuid2', obj.uuid)

        this.$store.commit('set_iconstatus', true)
        this.$router.push({
          name: 'department_detail',
          params: {
            name: obj.org_level_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == 'edit') {
        this.$store.commit('set_subPage_name', obj.org_level_name)
        this.$store.commit('set_uuid2', obj.uuid)

        this.$store.commit('set_iconstatus', false)
        this.$router.push({
          name: 'department_detail',
          params: {
            name: obj.org_level_name,
            uuid: obj.uuid,
          },
        })
      }
      if (item.type == 'del') {
        this.$myConfirm({ content: this.$t('message_Confirm_the_deletion') })
          .then(async () => {
            const del = await delDepartment({ uuid: obj.uuid })
            if (del.code == 200) {
              this.delData(obj.uuid)
              // this.$store.commit(
              //   'newsTips',
              //   this.$t('message_The_deletion_was_successful')
              // )
              this.$Message({
                text: this.$t("message_The_deletion_was_successful"),
              })
            }
          })
          .catch(() => { })
      }
    },
  },
  computed: {},
  watch: {
    async $route (val) {
      if (val.name == 'department_list') {
        await this.getData()
      }
    },
  },
}
</script>

<style scoped>
.title {
  display: flex;
  text-align: left;
}
.departmentName {
  font-size: 13px;
  flex: 1;
  margin-left: 5vw;
}
.staffNum {
  font-size: 13px;
  width: 17vw;
}
/* /deep/ .v-treeview-node__root {
  border-top: 1px solid #e8e8e8;
} */
/* /deep/ .v-treeview-node__root:last-child {
  border-bottom: none;
} */

/* /deep/ .v-treeview {
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-bottom: none;
} */
</style>
